module.exports = __webpack_public_path__ + "img/apple-f-pay.ced19975.svg";